// Strategy implementation types as published in the current
// subscription-integrations-backend rhino contract, plus the one node Capture
// adds itself: the form's post-submission questions, which has no API and
// carries the component ids to show instead.
const ClientApiStrategyTypes = {
  LOCATION_LIST: 'LocationList',
  APPOINTMENT_PICKING: 'AppointmentPicking',
  SOLAR_POTENTIAL: 'SolarPotential',
  POST_SUBMISSION_QUESTIONS: 'PostSubmissionQuestions',
};

export default ClientApiStrategyTypes;
